import { parseInt } from 'lodash'

import { ContractState } from '../store/slices/contractSlice'
import { ElectricityGridOperatorState } from '../store/slices/electricityGridOperatorSlice'
import { ProductDetailState } from '../store/slices/productDetailSlice'

type createPostBodyType = (
  payload: {[key:string]: any},
  productDetails: ProductDetailState,
  packageProposalData: ContractState,
  electricityGridOperator: ElectricityGridOperatorState,
) => {[key:string]: any}

export const getCload4PackageProposalQuery = (inputs: any) => {
  const resultingQuery = Object.keys(inputs).reduce((acc: any, val: any) => {
    if (inputs['pv-nominal-power-kwp']) {
      acc['pv-units'] = [{
        kwp: inputs['pv-nominal-power-kwp'].replace(',', '.'),
        comissioning: [
          inputs['generator-anlage-inbetriebnahme'].getFullYear(),
          (inputs['generator-anlage-inbetriebnahme'].getMonth() + 1).toString().padStart(2, '0'),
          inputs['generator-anlage-inbetriebnahme'].getDate().toString().padStart(2, '0')
        ].join('-')
      }]
    }

    if (inputs['pv-specific-yield-year-kwh-kwp']) {
      acc['battery-sizes-in-kwh'] = [10, 7.5]
    }

    if (inputs['intro-wae-vorjahresstromverbrauch'] && inputs['intro-wae-waermePaket'] === true) {
      acc['heat-power-consumption-in-kwh'] = inputs['intro-wae-vorjahresstromverbrauch'].replace(',', '.')
    }

    if (inputs['intro-wae-vorjahresstromverbrauch'] && inputs['intro-wae-waermePaket'] === true && inputs['intro-wae-heat-pump'] === '1') {
      acc['installation-after-jan2024'] = true
    }

    if (inputs['intro-wae-vorjahresstromverbrauch'] && inputs['intro-wae-waermePaket'] === true && inputs['intro-wae-heat-pump'] === '0') {
      acc['installation-after-jan2024'] = false
    }

    if (val === 'intro-faf-paketFamilyAndFriends' && inputs['intro-faf-paketFamilyAndFriends'] === true) {
      if (!acc['additional-consumption-point-in-kwh']) {
        acc['additional-consumption-point-in-kwh'] = []
      }

      acc['additional-consumption-point-in-kwh'].push({
        'pv-location-postal-code': inputs['intro-faf-1-postleitzahl'],
        'consumption-house-in-kwh': inputs['intro-faf-1-vorjahresstromverbrauch'].replace(',', '.')
      })

      if (inputs['intro-faf-2-details'] === true && inputs['intro-faf-paketFamilyAndFriends'] === true) {
        acc['additional-consumption-point-in-kwh'].push({
          'pv-location-postal-code': inputs['intro-faf-2-postleitzahl'],
          'consumption-house-in-kwh': inputs['intro-faf-2-vorjahresstromverbrauch'].replace(',', '.')
        })
      }
    }

    if (inputs['customer-postleitzahl']) {
      acc['pv-location-postal-code'] = inputs['customer-postleitzahl']
    }

    if (inputs['senec-system-id']) {
      acc['senec-system-id'] = inputs['senec-system-id']
    }

    if (inputs['intro-ctg-annual-mileage'] && inputs['intro-ctg-paketCloudToGo'] === true) {
      acc['ctg-mileage-per-year'] = inputs['intro-ctg-annual-mileage']
    }

    if (inputs['intro-ctg-car-consumption'] && inputs['intro-ctg-paketCloudToGo'] === true) {
      acc['ctg-consumption-in-kwh-per-hundred'] = inputs['intro-ctg-car-consumption'].replace(',', '.')
    }

    if (inputs['intro-ctg-at-home'] && inputs['intro-ctg-paketCloudToGo'] === true) {
      acc['ctg-percentage-charged-at-home'] = inputs['intro-ctg-at-home']
    }

    if (inputs['pv-system'] === '0' && inputs['grid-feed-year-kwh'] && inputs['power-consumption-year-kwh']) {
      acc['remaining-power-demand-in-kwh'] = inputs['power-consumption-year-kwh'].replace(',', '.')
      acc['total-feed-in-in-kwh'] = inputs['grid-feed-year-kwh'].replace(',', '.')
    } else if (inputs['pv-system'] === '1' && inputs['power-consumption-year-kwh']) {
      acc['consumption-house-in-kwh'] = inputs['power-consumption-year-kwh'].replace(',', '.')
    }

    if (val === 'pv-commissioning-date') {
      acc[val] = [
        inputs[val].getFullYear(),
        inputs[val].getMonth(),
        inputs[val].getDate()
      ].join('-')
    }
    return acc
  }, {})

  return resultingQuery
}

export const convertDate = (date: string) => {
  if (date) {
    const newDate = new Date(date)
    const userTimezoneOffset = newDate.getTimezoneOffset() * 60000
    const correctDate = new Date(newDate.getTime() - userTimezoneOffset)
    return correctDate.toISOString()
  } else {
    return ''
  }
}

export const createPostBody: createPostBodyType = (payload, productDetails, packageProposalData, electricityGridOperator) => {
  const energyProvidersData = drupalSettings.app_block.energy_providers_data
  const gutscheinValidierung = {
    schluessel: payload?.['p-overview']?.['overview-aktionscode'] ?? '',
    Betrag: payload?.['p-overview']?.['code-amount'] ?? '',
    informiert: payload?.['p-overview']?.['overview-bestens-informiert'] ?? '',
    kenntnisGenommen: payload?.['p-overview']?.['kenntnis-genommen'] ?? ''
  }
  const product = {
    productDetails: productDetails ?? ''
  }
  const packageProposal = {
    packageDetail: packageProposalData ?? ''
  }
  const electricityGridOperators = {
    gridOperatorsDetails: electricityGridOperator ?? ''
  }
  const personendaten : {[key: string]: any} = {
    postleitzahl: payload?.['p-customer']?.['customer-postleitzahl'] ?? '',
    telefonnummer: payload?.['p-customer']?.['customer-telefonnummer'] ?? '',
    nameFirma: payload?.['p-customer']?.['customer-firmenname'] ?? '',
    strasse: payload?.['p-customer']?.['customer-strasse']?.label ?? '',
    zusatz: '',
    nachname: payload?.['p-customer']?.['customer-nachname'] ?? '',
    anrede: payload?.['p-customer']?.['customer-anrede'] ?? '',
    vorname: payload?.['p-customer']?.['customer-vorname'] ?? '',
    type: payload?.['p-customer']?.['customer-type']
      ? parseInt(payload?.['p-customer']?.['customer-type'])
      : '',
    geburtstag: convertDate(payload['p-customer']['customer-geburtstag']),
    emailAdresse: payload?.['p-customer']
      ? [
          payload?.['p-customer']?.['customer-emailAddresse'],
          payload?.['p-generator']?.['generator-email2']
        ]
      : '',
    hausnummer: payload?.['p-customer']?.['customer-hausnummer'] ?? '',
    emailAdresseInstallateur: '',
    ort: payload?.['p-customer']?.['customer-ort']?.label ?? '',
    titel: payload?.['p-customer']?.['customer-titel'] ?? '',
    abwEntnahmestelle: {
      strasse_abw: payload?.['p-customer']?.['customer-strasse-abw']?.label ?? '',
      hausnummer_abw: payload?.['p-customer']?.['customer-hausnummer-abw'] ?? '',
      plz_abw: payload?.['p-customer']?.['customer-postleitzahl-abw'] ?? '',
      ort_abw: payload?.['p-customer']?.['customer-ort-abw']?.label ?? ''
    },
    werbeEinverstaendnis: payload?.['p-overview']?.['overview-bestens-informiert'] ?? ''
  }
  // Only construct personal data for Family and Friends if
  // intro-faf-paketFamilyAndFriends is checked.
  if (
    payload?.['p-intro']?.['intro-faf-paketFamilyAndFriends'] &&
    payload?.['p-intro']?.['intro-faf-1-details']
  ) {
    personendaten.familyfriendsEntnahmestelle = {
      strasse: payload?.['p-vendor']?.['vendor-faf-1-strasse']?.label ?? '',
      zusatz: '',
      postleitzahl: payload?.['p-vendor']?.['vendor-faf-1-postleitzahl'] ?? '',
      hausnummer: payload?.['p-vendor']?.['vendor-faf-1-hausnummer'] ?? '',
      ort: payload?.['p-vendor']?.['vendor-faf-1-ort']?.label ?? ''
    }
  }
  if (
    payload?.['p-intro']?.['intro-faf-paketFamilyAndFriends'] &&
    payload?.['p-intro']?.['intro-faf-2-details']
  ) {
    personendaten.familyfriends2Entnahmestelle = {
      strasse: payload?.['p-vendor']?.['vendor-faf-2-strasse']?.label ?? '',
      zusatz: '',
      postleitzahl: payload?.['p-vendor']?.['vendor-faf-2-postleitzahl'] ?? '',
      hausnummer: payload?.['p-vendor']?.['vendor-faf-2-hausnummer'] ?? '',
      ort: payload?.['p-vendor']?.['vendor-faf-2-ort']?.label ?? ''
    }
  }
  const zahlungsweise = {
    bankverbindung: {
      name: payload?.['p-customer']?.['customer-bankverbindung-nachname'] ?? '',
      bic: payload?.['p-customer']?.['customer-bankverbindung-bic'] ?? '',
      vorname: payload?.['p-customer']?.['customer-bankverbindung-vorname'] ?? '',
      geldinstitut: payload?.['p-customer']?.['customer-bankverbindung-geldinstitut'] ?? '',
      iban: payload?.['p-customer']?.['customer-bankverbindung-iban'] ?? ''
    },
    lastschrift: payload?.['p-customer']?.['customer-zahlungsweise'] === 'customer-zahlungsweise-lastschrift' ?? false
  }
  // Here we can see if intro-faf-paketFamilyAndFriends, intro-wae-waermePaket and
  // intro-ctg-paketCloudToGo is checked.
  const tarif = {
    paketFamilyAndFriends: payload?.['p-intro']?.['intro-faf-paketFamilyAndFriends']
      ? payload?.['p-intro']?.['intro-faf-1-details']
      : false,
    paketFamilyAndFriends2:
      payload?.['p-intro']?.['intro-faf-paketFamilyAndFriends']
        ? payload?.['p-intro']?.['intro-faf-2-details']
        : false,
    paketCloudToGo: payload?.['p-intro']?.['intro-ctg-paketCloudToGo'] ?? false,
    paketWaerme: payload?.['p-intro']?.['intro-wae-waermePaket'] ?? false,
    empfohlenerTarif: {},
    pumpeSepZaehler: payload?.['p-intro']?.['intro-wae-waermePaket'] ?? false,
    empfohlenerWaermeTarif: {}
  }
  const anlage1 = {
    anlageschluessel: payload?.['p-generator']?.['generator-anlageschluessel'] ?? '',
    anlagenbetreiberVorname: payload?.['p-generator']?.['generator-weitere-anlagenbetreiber-vorname'],
    anlagenbetreiberVorname2: payload?.['p-generator']?.['generator-weitere-anlagenbetreiber-vorname2'],
    anlagenbetreiberName: payload?.['p-generator']?.['generator-weitere-anlagenbetreiber-name'],
    anlagenbetreiberName2: payload?.['p-generator']?.['generator-weitere-anlagenbetreiber-name2'],
    anlagenbetreiberMail: payload?.['p-generator']?.['generator-email'],
    anlagenbetreiberMail2: payload?.['p-generator']?.['generator-email2'],
    anlagenstandortStrasse: payload?.['p-generator']?.['pv-address'] === '0'
      ? payload['p-generator']['generator-anlagenstandort-strasse']?.label
      : '',
    anlagenstandortHausnummer: payload?.['p-generator']?.['pv-address'] === '0'
      ? payload['p-generator']['generator-anlagenstandort-hausnummer']
      : '',
    anlagenstandortPostleitzahl: payload?.['p-generator']?.['pv-address'] === '0'
      ? payload['p-generator']['generator-anlagenstandort-postleitzahl']
      : '',
    anlagenstandortOrt: payload?.['p-generator']?.['pv-address'] === '0'
      ? payload['p-generator']['generator-anlagenstandort-ort']?.label
      : '',
    anlagenstandortMarktlokationsId: payload?.['p-generator']?.['generator-marktlokations-id'] ?? '',
    anlageLeistung: payload?.['p-generator']?.['generator-anlage-leistung'].replace(',', '.') ?? '',
    zaehlernummer: payload?.['p-generator']?.['generator-anlage-zaehlernummer'] ?? '',
    inbetriebnahme: payload?.['p-generator']
      ? convertDate(payload?.['p-generator']?.['generator-anlage-inbetriebnahme'])
      : '',
    zahlernummerErzeugungszahler: payload?.['p-generator']?.['generator-erzeugungszaehler-zaehlernummer'] ?? '',
    zahlernummerEinspeisezahler: payload?.['p-generator']?.['generator-einspeisezaehler-zaehlernummer'] ?? '',
    vertragsnummerBeimNetzbetreiber: payload?.['p-generator']?.['generator-contract-number'] ?? ''
  }
  const stromlieferant: {[key: string]: any} = {
    lichtstrom: {
      kuendigungSonderDatum: payload?.['p-vendor']
        ? convertDate(payload['p-vendor']['vendor-waerme-kuendigungSonderDatum'])
        : '',
      neuEingezogenDatum: payload?.['p-vendor']
        ? convertDate(payload['p-vendor']['vendor-waerme-neuEingezogenDatum'])
        : '',
      zaehlernummer: payload?.['p-vendor']?.['vendor-waerme-zaehlernummer'] ?? '',
      marktlokationsId: payload?.['p-vendor']?.['marktlokations-identifikationsnummer'] ?? '',
      anbieter: {
        nummer: payload?.['p-vendor']?.['vendor-waerme-anbieter']
          ? parseInt(payload?.['p-vendor']?.['vendor-waerme-anbieter'].value)
          : '',
        bdewNr: payload?.['p-vendor']?.['vendor-waerme-anbieter']
          ? parseInt(energyProvidersData[
            payload?.['p-vendor']?.['vendor-waerme-anbieter']?.value
          ]?.bdewNr)
          : '',
        name: payload?.stromlieferantName?.lichtstrom ?? ''
      },
      neuEingezogen: payload?.['p-vendor']
        ? payload['p-vendor']['vendor-waerme-wechselgrund'] ===
          'vendor-waerme-neuEingezogen'
        : false,
      lieferantenwechsel: payload?.['p-vendor']
        ? payload['p-vendor']['vendor-waerme-wechselgrund'] ===
        'vendor-waerme-lieferantwechsel'
        : false,
      kuendigungSonder: payload?.['p-vendor']?.['vendor-waerme-kuendigungSonder'] ?? '',
      bisherigerKundenname: payload?.['p-vendor']?.['vendor-waerme-kuendigungSonder-vertragspartner'] ?? ''
    },
    umsatzsteuer: {
      kleinunternehmer: false,
      steuerAbfuehren: payload?.['p-generator']?.['generator-steuerAbfuehren'] ?? ''
    }
  }
  // Only construct electricity provider for Waerme package if
  // intro-wae-waermePaket is checked.
  if (payload?.['p-intro']?.['intro-wae-waermePaket']) {
    stromlieferant.waermestrom = {
      kuendigungSonderDatum: payload?.['p-vendor']
        ? convertDate(payload?.['p-vendor']?.['vendor-wae-kuendigungSonderDatum'])
        : '',
      vorjahresstromverbrauch: payload?.['p-intro']?.['intro-wae-vorjahresstromverbrauch'].replace(',', '.') ?? '',
      neuEingezogenDatum: payload?.['p-vendor']
        ? convertDate(payload?.['p-vendor']?.['vendor-wae-neuEingezogenDatum'])
        : '',
      zaehlernummer: payload?.['p-vendor']?.['vendor-wae-zaehlernummer'] ?? '',
      marktlokationsId: payload?.['p-vendor']?.['vendor-wae-marktlokations-id'] ?? '',
      anbieter: {
        nummer: payload?.['p-vendor']?.['vendor-wae-anbieter']
          ? parseInt(payload?.['p-vendor']?.['vendor-wae-anbieter'].value)
          : '',
        bdewNr: payload?.['p-vendor']
          ? parseInt(energyProvidersData[payload?.['p-vendor']?.['vendor-wae-anbieter']?.value]?.bdewNr)
          : '',
        name: payload?.stromlieferantName?.waermestrom ?? ''
      },
      neuEingezogen: payload?.['p-vendor']
        ? payload?.['p-vendor']?.['vendor-wae-wechselgrund'] ===
        'vendor-wae-neuEingezogen'
        : false,
      lieferantenwechsel: payload?.['p-vendor']
        ? payload?.['p-vendor']?.['vendor-wae-wechselgrund'] ===
          'vendor-wae-lieferantwechsel'
        : false,
      kuendigungSonder: payload?.['p-vendor']?.['vendor-wae-kuendigungSonder'] ?? ''
    }
  }
  // Only construct electricity provider for Family and Friends if
  // intro-faf-paketFamilyAndFriends is checked.
  if (
    payload?.['p-intro']?.['intro-faf-paketFamilyAndFriends'] &&
    payload?.['p-intro']?.['intro-faf-1-details']
  ) {
    stromlieferant.familyAndFriends = {
      vorname: payload?.['p-vendor']?.['vendor-faf-1-vorname'] ?? '',
      name: payload?.['p-vendor']?.['vendor-faf-1-name'] ?? '',
      vorjahresstromverbrauch: payload?.packages?.['intro-faf-1-vorjahresstromverbrauch'].replace(',', '.') ?? '',
      kuendigungSonderDatum: payload?.['p-vendor']
        ? convertDate(payload?.['p-vendor']?.['vendor-faf-1-kuendigungSonderDatum'])
        : '',
      neuEingezogenDatum: payload?.['p-vendor']
        ? convertDate(payload?.['p-vendor']?.['vendor-faf-1-neuEingezogenDatum'])
        : '',
      zaehlernummer: payload['p-vendor']['vendor-faf-1-zaehlernummer'] ?? '',
      marktlokationsId: payload?.['p-vendor']?.['vendor-faf-1-marktlokations-id'] ?? '',
      anbieter: {
        nummer: payload?.['p-vendor']?.['vendor-faf-1-anbieter']
          ? parseInt(payload?.['p-vendor']?.['vendor-faf-1-anbieter'].value)
          : '',
        bdewNr: payload?.['p-vendor']
          ? parseInt(energyProvidersData[payload?.['p-vendor']?.['vendor-faf-1-anbieter'].value]?.bdewNr)
          : '',
        name: payload?.stromlieferantName?.familyAndFriends ?? ''
      },
      neuEingezogen: payload?.['p-vendor']?.['vendor-faf-1-wechselgrund'] ===
        'vendor-faf-1-neuEingezogen',
      lieferantenwechsel: payload?.['p-vendor']?.['vendor-faf-1-wechselgrund'] ===
        'vendor-faf-1-lieferantwechsel',
      kuendigungSonder: payload?.['p-vendor']?.['vendor-faf-1-kuendigungSonder'] ?? ''
    }
  }
  if (
    payload?.['p-intro']?.['intro-faf-paketFamilyAndFriends'] &&
    payload?.['p-intro']?.['intro-faf-2-details']
  ) {
    stromlieferant.familyAndFriends2 = {
      vorname: payload?.['p-vendor']?.['vendor-faf-2-vorname'] ?? '',
      name: payload?.['p-vendor']?.['vendor-faf-2-name'] ?? '',
      vorjahresstromverbrauch: payload?.packages?.['intro-faf-2-vorjahresstromverbrauch'].replace(',', '.') ?? '',
      kuendigungSonderDatum: payload?.['p-vendor']
        ? convertDate(payload?.['p-vendor']?.['vendor-faf-2-kuendigungSonderDatum'])
        : '',
      neuEingezogenDatum: payload?.['p-vendor']
        ? convertDate(payload?.['p-vendor']?.['vendor-faf-2-neuEingezogenDatum'])
        : '',
      zaehlernummer: payload?.['p-vendor']?.['vendor-faf-2-zaehlernummer'] ?? '',
      marktlokationsId: payload?.['p-vendor']?.['vendor-faf-2-marktlokations-id'] ?? '',
      anbieter: {
        nummer: payload?.['p-vendor']?.['vendor-faf-2-anbieter']
          ? parseInt(payload?.['p-vendor']?.['vendor-faf-2-anbieter'].value)
          : '',
        bdewNr: payload?.['p-vendor']
          ? parseInt(energyProvidersData[payload?.['p-vendor']?.['vendor-faf-2-anbieter'].value]?.bdewNr)
          : '',
        name: payload?.stromlieferantName?.familyAndFriends2 ?? ''
      },
      neuEingezogen: payload?.['p-vendor']
        ? payload?.['p-vendor']?.['vendor-faf-2-wechselgrund'] ===
        'vendor-faf-2-neuEingezogen'
        : false,
      lieferantenwechsel: payload?.['p-vendor']
        ? payload?.['p-vendor']?.['vendor-faf-2-wechselgrund'] ===
        'vendor-faf-2-lieferantwechsel'
        : false,
      kuendigungSonder: payload?.['p-vendor']?.['vendor-faf-2-kuendigungSonder'] ?? ''
    }
  }
  const verbrauch = {
    groessePV: payload?.['p-intro']?.['pv-nominal-power-kwp']
      ? payload?.['p-intro']?.['pv-nominal-power-kwp'].replace(',', '.')
      : '',
    stromspeicher: {
      stromspeicherId: payload?.['p-intro']?.['senec-system-id']
        ? parseInt(payload?.['p-intro']?.['senec-system-id'])
        : ''
    },
    powerConsumptionYearKwh: payload?.['p-intro']?.['power-consumption-year-kwh']
      ? parseInt(payload?.['p-intro']?.['power-consumption-year-kwh'])
      : ''
  }
  const erstelldatum = new Date().toISOString()
  const version = '3.0'
  const otherProperties = ''
  const requestPayload = {
    gutscheinValidierung,
    product,
    packageProposal,
    electricityGridOperators,
    personendaten,
    verbrauch,
    stromlieferant,
    zahlungsweise,
    tarif,
    anlage1,
    version,
    erstelldatum,
    otherProperties
  }

  // Set otherProperties.
  requestPayload.otherProperties = JSON.stringify(requestPayload)

  return requestPayload
}
